import React from "react";
import styles from './qualityCheck.module.scss'
import {useDispatch} from "react-redux";
import {changeQualifiedStatusForPromotionsAndItems} from "../../store/actionCreators/promotionsItemsCreators";
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {Box, createTheme, Typography, ThemeProvider} from "@mui/material";
import {makeStyles} from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";

import {QualityCheckStatistic} from "../qualityCheckStatistic/qualityCheckStatistic";
import {ReactComponent as InfoIcon} from "../../assets/info_icon.svg";

const useStyles = makeStyles(() => ({
    qualificationMiniPopup: {
        cursor: "pointer",
        // margin: 0
    },
}));

const theme = createTheme({
    components: {
        // Name of the component
        MuiTooltip: {
            styleOverrides: {
                // Name of the slot
                popper: {
                    margin: 0,
                },
                tooltip: {
                    // Some CSS
                    backgroundColor: '#ffffff',
                    color: '#000000',
                    // border: '1px solid #4D4D4D',
                    // maxWidth: `100%`,
                    borderRadius: '5px',
                    // width: `180px`,
                    padding: `10px`,
                    boxShadow: `rgba(0, 0, 0, 0.35) 0px 5px 15px`,
                    '&.MuiTooltip-tooltipPlacementBottom': {
                        margin: `0!important`
                    }
                },
            },
        },
    },
});

interface Props {
    withCheckbox?: boolean
}

export const QualityCheck: React.FC<Props> = ({
                                                  withCheckbox = true
                                              }) => {
    const dispatch = useDispatch();
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    const classes = useStyles();


    const onChange = ((e: React.ChangeEvent<HTMLInputElement>) => {
        const targetStatus = e.target.checked;
        dispatch(changeQualifiedStatusForPromotionsAndItems(targetStatus))
    })
    return (
        <div className={styles.qualification_wrapper}>
            {
                withCheckbox && <>
                    <div className={styles.input_wrapper}>
                        <input type="checkbox" checked={promotionsItemsState.isQualified} onChange={onChange}
                               id={`qualified_promos_items_checkbox`}/>
                        <label htmlFor={`qualified_promos_items_checkbox`}>

                        </label>
                    </div>
                    <Box>
                        <Typography fontFamily={`inherit`} fontSize={`14px`} fontWeight={`700`} lineHeight={1}>
                            Quality Check
                        </Typography>
                    </Box>
                </>
            }
            <ThemeProvider theme={theme}>
                <Tooltip
                    enterDelay={500}
                    enterNextDelay={500}
                    title={<QualityCheckStatistic/>}
                    placement={"bottom-start"}
                    className={classes.qualificationMiniPopup}
                >
                    <Box sx={{display: `flex`, margin: `0 5px`}}>
                        <InfoIcon/>
                    </Box>
                </Tooltip>
            </ThemeProvider>
        </div>
    )
}